export const enum SettingsTabs {
  GENERAL = 'general',
  PRICES = 'prices',
  DOCUMENTS = 'documents',
  ADDITIONAL_SERVICES = 'additional_services',
  STEPS = 'steps',
}

export enum PricesTabs {
  APPRAISER = 'Appraiser',
  PHOTO_SHOOTING = 'PhotoShooting',
  DOCUMENTS = 'Documents',
  SETTLEMENT = 'Settlement',
}
